import React, { useContext, useEffect, useState } from 'react';
import { Props } from './Handbooks.types';
import { Styled } from './Handbooks.styles';
import configs from './configs';
import { Page } from '../components/Page';
import { mainCordovaContext } from '../context';
import { useHistory } from 'react-router';

import { NavigationStyled } from '../Navigation';
import { IconButton } from 'office-ui-fabric-react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../reducer/user';
import outIcon from '../../../../images/sign-out.svg';
import navIcon from 'images/navButton.svg';
import {LogoutButton, NavigationButton} from '../components/NavigationButton';

export const Handbooks: React.FC<Props> = () => {
  const { toggleNavigation } = useContext(mainCordovaContext);
  const history = useHistory();

  const dispatch = useDispatch();

  return (
    <Page
      actionButton={<LogoutButton />}
      title={'Справочники'}
      primaryButtonNode={<NavigationButton />}

    >
      <Styled.Menu>
        {Object.keys(configs).map((cfg: string) => {
          return (
            <NavigationStyled.NavButton
              key={`tst-${cfg}`}
              to={`/handbooks/${cfg}`}
            >
              {configs[cfg].title}
            </NavigationStyled.NavButton>
          );
        })}
      </Styled.Menu>
    </Page>
  );
};
